const e = "рік", t = "м³", a = { year: "рік", qubicMeter: "м³" };
export {
  a as default,
  t as qubicMeter,
  e as year
};
//# sourceMappingURL=units.json.js.map
